import { VIEW_MODES } from 'crazyEditor/core/constants/editorConstants';
import { store } from 'crazyEditor/redux/store';

export function getViewState(viewMode) {
  return (viewMode || store.getState().editor.viewMode) === VIEW_MODES.MOBILE ? 'mobile' : 'desktop';
}
